export const LANGS_LIST_LOAD = 'LANGS_LIST_LOAD'
export const LANGS_LIST_SELECT_LANG = 'LANGS_LIST_SELECT_LANG'
export const LANGS_LIST_CHANGE_LANG = 'LANGS_LIST_CHANGE_LANG'
export const LANGS_LIST_CLEAR = 'LANGS_LIST_CLEAR'

export const COMMANDS_LIST_LOAD = 'COMMANDS_LIST_LOAD'
export const COMMANDS_LIST_LOAD_SUCCESS = 'COMMANDS_LIST_LOAD_SUCCESS'
export const COMMANDS_LIST_LOAD_FILED = 'COMMANDS_LIST_LOAD_FILED'
export const COMMANDS_LIST_CLEAR = 'COMMANDS_LIST_CLEAR'

export const SEARCH_REUSLT_LOAD = 'SEARCH_REUSLT_LOAD'
export const SEARCH_REUSLT_CLEAR = 'SEARCH_REUSLT_CLEAR'

export const ASSISTENT_SET_RESULT = 'ASSISTENT_SET_RESULT'
export const ASSISTENT_CLEAR_RESULT = 'ASSISTENT_CLEAR_RESULT'
export const ASSISTENT_ACTION = 'ASSISTENT_ACTION'
export const ASSISTENT_ACTION_SAY = 'ASSISTENT_ACTION_SAY'
export const ASSISTENT_ACTION_FIND_STRING = 'ASSISTENT_ACTION_FIND_STRING'
export const ASSISTENT_ACTION_FIND_STRING_FILED = 'ASSISTENT_ACTION_FIND_STRING_FILED'

export const FETCH_ANSWERS_REQUEST = 'FETCH_ANSWERS_REQUEST'
export const FETCH_ANSWERS_REQUEST_SUCCESS = 'FETCH_ANSWERS_REQUEST_SUCCESS'
export const FETCH_ANSWERS_REQUEST_FILED = 'FETCH_ANSWERS_REQUEST_FILED'



// WEBPACK FOOTER //
// ./src/actionTypes.js